import { filterPartiesByPartyTypeCode } from "./filterPartiesByPartyTypeCode";

export const getAllPrimaryBeneficiaryFromParties = (parties) => {
  return filterPartiesByPartyTypeCode(parties, ["PB"]);
};
